import { render, staticRenderFns } from "./ModalRepresentante.vue?vue&type=template&id=6a876689&scoped=true"
import script from "./ModalRepresentante.vue?vue&type=script&lang=js"
export * from "./ModalRepresentante.vue?vue&type=script&lang=js"
import style0 from "./ModalRepresentante.vue?vue&type=style&index=0&id=6a876689&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a876689",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a876689')) {
      api.createRecord('6a876689', component.options)
    } else {
      api.reload('6a876689', component.options)
    }
    module.hot.accept("./ModalRepresentante.vue?vue&type=template&id=6a876689&scoped=true", function () {
      api.rerender('6a876689', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/ModalRepresentante.vue"
export default component.exports